var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-collapse",style:(_vm.styles),on:{"transitionend":_vm.onTransitionEnd}},[_c('div',{ref:"content",staticClass:"m-collapse__content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }